import {Pipe, PipeTransform, inject} from '@angular/core';
import LinkifyIt from 'linkify-it';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Pipe({
  name: 'linkify',
  standalone: true
})
export class LinkifyPipe implements PipeTransform {
  private sanitizer: DomSanitizer = inject(DomSanitizer);

  private linkify: LinkifyIt = new LinkifyIt();

  public transform(value: string): SafeHtml {
    if (!value) {
      return value;
    }

    const matches = this.linkify.match(value);

    if (!matches) {
      return value;
    }

    let result = value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matches.forEach((match: { url: any; }) => {
      const url = match.url;
      const anchorTag = '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
      result = result.replace(url, anchorTag);
    });

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
